import {
  TERMINAL_SUMMARY_LIST_FETCH_REQUEST,
  TERMINAL_SUMMARY_LIST_FETCH_REQUEST_SUCCESS,
  TERMINAL_SUMMARY_LIST_FETCH_REQUEST_FAILURE,
  TERMINAL_SUMMARY_LIST_CLEAN_REQUEST,
} from 'constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

const terminalSummaryListReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case TERMINAL_SUMMARY_LIST_FETCH_REQUEST:
      return Object.assign({}, state, { loading: true, payload: [] });

    case TERMINAL_SUMMARY_LIST_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.data.currentPage,
          pageSize: action.data.data.pageSize,
          total: action.data.data.totalRecord,
          totalPage: action.data.data.totalPage,
        },
      });

    case TERMINAL_SUMMARY_LIST_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case TERMINAL_SUMMARY_LIST_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export default terminalSummaryListReducer;
